import { useState } from "react";
import { Box, Card, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";

import PageContainer from "../../../components/container/PageContainer";
import Breadcrumb from "../../../layouts/full-layout/breadcrumb/Breadcrumb";

import AddDashboardModules from "./AddDashboardModules";
import AddDashboardModulePages from "./AddDashboardModulePages";
import AddDashboardModulePagesAccess from "./AddDashboardModulePagesAccess";
import AddDefaultPagesAccess from "./AddDefaultPageAccess";

const DashboardModulesManagement = () => {
  const [value, setValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const BCrumb = [
    { to: "/", title: "Admin" },
    { title: "Dashboard's Modules Management" },
  ];

  return (
    <PageContainer title="Dashboard's Modules Management">
      <Breadcrumb
        title="Dashboard's Modules Management"
        items={BCrumb}
      />

      <Card>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <TabList onChange={handleTabChange} variant="fullWidth">
              <Tab label="Add Dashboard's Modules" value="1" />

              <Tab label="Add Dashboard's Module Pages" value="2" />

              {/* <Tab label="Add Dashboard's Module's Pages Access" value="3" /> */}

              <Tab label="Add Default Pages Access" value="4" />
            </TabList>
          </Box>

          <TabPanel value="1">
              <AddDashboardModules />
            </TabPanel>

          <TabPanel value="2">
            <AddDashboardModulePages />
          </TabPanel>

          <TabPanel value="3">
            <AddDashboardModulePagesAccess />
          </TabPanel>

          <TabPanel value="4">
            <AddDefaultPagesAccess />
          </TabPanel>
        </TabContext>
      </Card>
    </PageContainer>
  );
};

export default DashboardModulesManagement;